$(document).foundation();

$(document).ready(function () {
    // utils
    initVerticalCenter();
    initAnimateInView();
    inlineSVGs([
		'.footer__social img'
    ]);

    // global
    initSliders();
    initVideoPopups();
	initForms();
	initAccordions();
	initSharing();
	initFilters();
	initOffCanvas();
	initAnchors();
	initVideoPopups();
	
	// template specific
	initTeams();
	initJobDetail();
});


 
 
 



function initVerticalCenter() {
    $('.vertical-center').each(function () {
        $(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
    });
}



// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(inputValue) {
    var selectorString = '';
    if (typeof inputValue === "object") {
        selectorString = inputValue.join(',');
    } else {
        selectorString = inputValue;
    }

    $(selectorString).each(function () {
        var $img = $(this);
        var imgID = $img.attr('id');
        var imgClass = $img.attr('class');
        var imgURL = $img.attr('src');
        
        if (imgURL.indexOf('.svg') > -1) {
	        $.get(imgURL, function (data) {
	            // Get the SVG tag, ignore the rest
	            var $svg = $(data).find('svg');
	
	            // Add replaced image's ID to the new SVG
	            if (typeof imgID !== 'undefined') {
	                $svg = $svg.attr('id', imgID);
	            }
	            // Add replaced image's classes to the new SVG
	            if (typeof imgClass !== 'undefined') {
	                $svg = $svg.attr('class', imgClass + ' replaced-svg');
	            }
	
	            // Remove any invalid XML tags as per http://validator.w3.org
	            $svg = $svg.removeAttr('xmlns:a');
	
	            // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
	            if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	                $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	            }
	
	            // Replace image with new SVG
	            $img.replaceWith($svg);
	        }, 'xml');
        }
    });
}



function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}



/**
 * Scales any element to simulate the CSS background-size: cover property.
 * @param {DOMelement} element The element to scale
 * @param {bool} [scaleToParent] Scale the element to fill the parent instead
 *                               of the whole browser window.
 */
function coverViewport(element, scaleToParent) {
    if (typeof scaleToParent === 'undefined') { scaleToParent = false; }

    var viewportWidth, viewportHeight;
    if (scaleToParent) {
        viewportWidth = $(element).parent().innerWidth();
        viewportHeight = $(element).parent().innerHeight();
    } else {
        viewportWidth = $(window).innerWidth();
        viewportHeight = $(window).innerHeight();
    }

    var $element = $(element);

    var elementWidth = $element.attr('width');
    var elementHeight = $element.attr('height');

    // Aspect ratio = height / width
    var viewportRatio = viewportHeight / viewportWidth;
    var videoRatio = elementHeight / elementWidth;

    //console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


    var newWidth = (elementWidth / elementHeight) * viewportHeight
    var newHeight = (elementHeight / elementWidth) * viewportWidth;
    var newTop = 0;

    if (viewportRatio > videoRatio) {
        // set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
        //console.log('crop left and right');
        $element.css('height', viewportHeight);
        $element.css('width', newWidth);
        $element.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
        $element.css('top', '0');
    } else if (viewportRatio < videoRatio) {
        // set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
        //console.log('crop top and bottom');
        $element.css('width', viewportWidth);
        $element.css('height', newHeight);
        $element.css('left', '0');
        $element.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
    } else {
        // set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
        //console.log('no crop');
        $element.css('height', viewportHeight);
        $element.css('width', viewportWidth);
        $element.css('left', '0');
        $element.css('top', '0');
    }
}



function initAnimateInView() {
	$(window).on('DOMContentLoaded load resize scroll', animateElementsInView);
	animateElementsInView();
}

function animateElementsInView() {
	$('[data-animate-in-view]').each(function () {
		if ( $(this).hasClass('in-view') ) {
			return;	
		}
		
		if ( isElementInViewport($(this)) ) {
			var elementToAnimate = this;
			
			$(elementToAnimate).addClass('in-view'); // log that this element has been seen
			
			
			setTimeout(function () {
				$(elementToAnimate).addClass( $(elementToAnimate).data('animate-in-view') ); // apply the animation class
			}, 300);
			
			
			if ( typeof $(elementToAnimate).data('map-load-on-view') != 'undefined' ) { // only load this map once it's in view
				buildMap(elementToAnimate);
			}
		}
	});
}

function isElementInViewport (el) {
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}
	
	var rect = el.getBoundingClientRect();
	
	var t = rect.y;
	var b = window.innerHeight - rect.y - rect.height;
	var h = window.innerHeight;
	
	if (
		( (t >= 0) && (t <= h) ) ||
		( (b >= 0) && (b <= h) )
	) {
		return true;
	} else {
		return false;
	}
}











function initSliders() {
	/*$('.slider__inner').reformSlider({
		autoPlay: true,
		speed: 4000,
		animationSpeed: 1000,
		arrows: false
	});*/
	
	$('.slider__inner').slick({
		autoplay: true,
		fade: true,
		autoplaySpeed: 4000,
		arrows: false
	});

	pushContentBelowHeader()
	$(window).on('resize', pushContentBelowHeader);
	
	if ( $('.slider__slide iframe').length > 0 ) {
		coverViewport('.slider__slide iframe');
		$(window).on('resize', function () {
			coverViewport('.slider__slide iframe');
		});
	}

	$('.slider__scroll button').on('click', function () {
		$('html, body').animate({
			scrollTop: $('.slider, .map').outerHeight()
		}, 1000);
		
		return false;
	});
	
	
	$('.image-text-slider').each(function () {
		if ( $(this).find('.image-text-slider__item').length > 1 ) {
			$(this).addClass('has-arrows');
		}
		
		$(this).slick({
			arrows: true
		});
	});
	
	
	
	$('.carousel__wrap').each(function () {
		$carousel = $(this);
		
		if ( $carousel.find('.carousel__item').length > 3 ) {
			$carousel.addClass('has-arrows');
		}
		
		if ( $carousel.find('.carousel__item').length > 2 ) {
			$carousel.slick({
				slidesToShow: 3,
				arrows: true,
				centerMode: true,
				centerPadding: 0,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2
						}
					},
					{
						breakpoint: 640,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
		} else {
			$carousel.addClass('not-enough-slides');
		}
	});
}

function pushContentBelowHeader() {
	$('main').css('padding-top', $('.header').outerHeight() + 'px');
}





function initVideoPopups() {
	var $modal;
	var modal = '<div id="video-modal" class="gallery-modal gallery-modal--video full reveal" data-reveal><button class="gallery-modal__close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="gallery-modal__iframe"><iframe frameborder="0" src="{{iframeSrc}}"></iframe></div></div>';

	// Detect video links and embed them in a popup
	$('a[href*="youtu"], a[href*="vimeo.com"]').not('[href*="youtube.com/channel"]').addClass('is-video').on('click', function () {
		$modal = $( modal.replace('{{iframeSrc}}', generateVideoEmbedUrl($(this).attr('href'))) );

		$('body').append($modal);

		$('#video-modal').foundation();
        $modal.foundation('open');

        $modal.on('closed.zf.reveal', function () {
	        $modal.remove();
        });

		return false;
	});
}

function generateVideoEmbedUrl(videoUrl) {
	if (videoUrl.indexOf('youtube.com/embed') > -1) {
		// already a YouTube embed code, return same link
		return videoUrl;
	} else if (videoUrl.indexOf('youtu') > -1) {
		// must be either a full or shortened YouTube url so parse and create embed link
	    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
	    var match = videoUrl.match(regExp);

	    if (match && match[2].length == 11) {
	        return 'https://www.youtube.com/embed/' + match[2] + '?rel=0&autoplay=1&modestbranding=1';
	    } else {
	        return videoUrl;
	    }
	} else if (videoUrl.indexOf('player.vimeo.com') > -1) {
		// already a Vimeo embed code, return same link
		return videoUrl;
	} else if (videoUrl.indexOf('https://vimeo.com/') > -1) {
		// normal Vimeo link, so generate and embed code
		return 'https://player.vimeo.com/video/' + videoUrl.split('/')[3] + '?autoplay=true&byline=false&portrait=false&title=false';
	}

	// if all else fails, return the original link
	return embedUrl;
}




function initForms() {
	$('.form select').selectric();
	
	$('.search__toggle').on('click', function () {
		$(this).toggleClass('on');
		$('.search form').slideToggle();
	});
}



function initAccordions() {
	$('.accordion__wrap').accordiom();
	
	$('.job-detail__share').accordiom({
		showFirstItem: false
	});
}


function initSharing() {
	$('a[data-share-twitter]').attr('href', 'http://twitter.com/share?text=' + $('h1').text() + '&url=' + window.location.href);
	$('a[data-share-facebook]').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href);
	$('a[data-share-linkedin]').attr('href', 'https://www.linkedin.com/sharing/share-offsite/?url=' + window.location.href);
}


function initFilters() {
	$('.properties__filter-controls select').selectric();
	
	$('.properties').on('filter-changed', function () {
		$('.properties [data-animate-in-view]').each(function () {
			$(this).addClass( $(this).data('animate-in-view') );
		});
	});
}



function initTeams() {
	// sort of custom accordiom
	$('.teams__toggle button').on('click', function () {
		var $selectorEl = $(this).parents('.teams__item');
		
		if ($(this).is('.on')) {
			$selectorEl.find('.teams__additional').slideUp();
			$(this).removeClass('on');
		} else {
			$('.teams__additional').slideUp();
			$('.teams__toggle button').removeClass('on');

			$selectorEl.find('.teams__additional').slideDown();
			$(this).addClass('on');
		}

	});
}



function initOffCanvas() {
	//$('#offCanvas').foundation('open');
	
	$('.off-canvas__nav-primary > ul > li').each(function () {
		// Automatically add the "Overview" links to the landing page
		if ( $(this).find('ul').length > 0 ) {
			var overviewLink = $(this).find('a').first().attr('href');
			$(this).find('ul').prepend('<li class="offcanvas__overview-link"><a href="' + overviewLink + '">Overview</a></li>');
		}
	});
	
	
	$('.off-canvas__nav-primary > ul > li > a').on('click', function () {
		if ( $(this).next('.off-canvas__nav-sub').length > 0 ) { // only trigger if there are sub pages to show
			if ( $(this).parent().hasClass('open') ) {
				// second click of main item allows clicking directly through
				return true;
			} else {
				// close any other open items
				$('.off-canvas__nav-primary > ul > li.open').removeClass('open').find('.off-canvas__nav-sub').slideUp();
				
				// and open the new one
				$(this).parent().addClass('open');
				$(this).next().slideDown();
			}
			return false; // prevent navigating
		}
	});
}




function initJobDetail() {
	if ( $('.job-detail').length > 0 ) {
		equalizeJobDetail();
		$(window).on('resize', equalizeJobDetail);
	}
}

function equalizeJobDetail() {
	var contentHeight = $('.job-detail__content').outerHeight() || 0;
	var sidebarHeight = $('.job-detail__sidebar-inner').outerHeight() || 0;
	
	if (sidebarHeight > contentHeight) {
		$('.job-detail__content').css('height', sidebarHeight);
	}
}




function initAnchors() {
	if ( window.location.hash !== '' ) {
		var hashValue = window.location.hash.replace('#', '').toLowerCase();
		
		$('h2').each(function () {
			var headingText = $(this).text().toLowerCase();
			headingText = headingText.replace(/\s+/g, '-'); // spaced become hyphens
			headingText = headingText.replace(/'/g, ''); // remove all apostrophes
			headingText = headingText.replace(/,/g, ''); // remove all commas
			
			if (headingText === hashValue) {
				// Need to complete all animations before scrolling position can be found
				$('[data-animate-in-view]').each(function () {
					$(this).addClass('transition--none').removeClass('transform--will-slide-in transform--will-slide-in-right transform--will-fade-in transform--will-fade-up transform--will-fade-down transform--will-fade-left transform--will-fade-right');
				});
				
				$('html, body').animate({
					scrollTop: $(this).offset().top - $('.header').outerHeight() - 20
				}, 1000);
				
				return false;
			}
		});
	}
}





function initVideoPopups() {
	
	// Detect video links and embed them in a popup
	$('a[href*="youtu"], a[href*="vimeo.com"]').not('[href*="youtube.com/channel"]').addClass('is-video').on('click', function () {
		openVideo($(this).attr('href'));
		
		return false;
	});
	
	
	// Buttons work differently for some reason
	$('button[onclick*="youtu"], button[onclick*="vimeo.com"]').not('[onclick*="youtube.com/channel"]').addClass('is-video').each(function () {
		//console.log( $(this).attr('onclick').replace("'", '').split('=')[1].replace("'", '')  );
		var videoLink = $(this).attr('onclick').replace("'", '').split('=');
		if (videoLink.length > 1) {
			videoLinkURL = videoLink[1].replace("'", '');
			$(this)[0].setAttribute('onclick', "openVideo('" + videoLinkURL + "')");
		}
	});
}


function openVideo(videoLink) {

	var $modal;
	var modal = '<div id="video-modal" class="gallery-modal gallery-modal--video full reveal" data-reveal data-animation-in="fade-in" data-animation-out="fade-out"><button class="gallery-modal__close" data-close aria-label="Close modal" type="button"><span aria-hidden="true">Close</span></button><div class="gallery-modal__iframe"><iframe frameborder="0" src="{{iframeSrc}}"></iframe></div></div>';
	
	$modal = $( modal.replace('{{iframeSrc}}', generateVideoEmbedUrl(videoLink)));
		
	$('body').append($modal);
	
	$('#video-modal').foundation();
	$modal.foundation('open');
	
	$modal.on('closed.zf.reveal', function () {
		$modal.remove();
	});
	
	return false;
}

function generateVideoEmbedUrl(videoUrl) {
	if (videoUrl.indexOf('youtube.com/embed') > -1) {
		// already a YouTube embed code, return same link
		return videoUrl;
	} else if (videoUrl.indexOf('youtu') > -1) {
		// must be either a full or shortened YouTube url so parse and create embed link
		var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
		var match = videoUrl.match(regExp);
	
		if (match && match[2].length == 11) {
			return 'https://www.youtube.com/embed/' + match[2] + '?rel=0&autoplay=1&modestbranding=1';
		} else {
			return videoUrl;
		}		
	} else if (videoUrl.indexOf('player.vimeo.com') > -1) {
		// already a Vimeo embed code, return same link
		return videoUrl;
	} else if (videoUrl.indexOf('https://vimeo.com/') > -1) {
		// normal Vimeo link, so generate and embed code
		return 'https://player.vimeo.com/video/' + videoUrl.split('/')[3] + '?autoplay=true&byline=false&portrait=false&title=false';
	}
	
	// if all else fails, return the original link
	return embedUrl;
}






